import { render, staticRenderFns } from "./NTableView.vue?vue&type=template&id=b7d1cccc"
import script from "./NTableView.vue?vue&type=script&lang=js"
export * from "./NTableView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports